import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { StyledHeaderButton, TextButton } from './styles';
import RoutesUtils from '../../../../utils/routes';
import { MenuItemType } from '../../../../typings/menu';
import { MenuActionKeys, openCustomItem } from '../../actions';
import UserAgentUtils from '../../../../utils/userAgent';
import  Tooltip from '../../../../components/Tooltip';
import { GalleryInfosState } from '../../../Gallery/reducer';
import { DriveListState } from '../../../DriveItemList/reducer';

const Translate = require('react-redux-i18n').Translate;

interface HeaderButtonProps {
	icon?: string;
	label?: string;
	type?: MenuItemType;
	target?: string;
	dispatch: Dispatch<StoreState>;
	galleryInfos: GalleryInfosState;
	driveList: DriveListState;
}

const HeaderButton = (props: HeaderButtonProps) => {
	const handleClick = () => {
		const { target, type, dispatch } = props;

		switch (type) {
			case MenuItemType.Link:
			case MenuItemType.Asset:
			case MenuItemType.Folder:
			case MenuItemType.Page:
				dispatch(openCustomItem(type, target as string));
				break;
			case MenuItemType.BurgerButton:
				dispatch({ type: MenuActionKeys.REQUEST_OPEN_LEFT_MENU });
				break;
			default:
				RoutesUtils.historyPush(target as string);
				break;
		}
	};

	const getImgElement = () => {
		const { icon, galleryInfos, driveList } = props;
		const { driveItems, resolutions } = driveList;

		if (icon) {
			const iconId = Utils.getMediaId(icon);
			if (iconId > -1 && driveItems[iconId]) {
				const src = Utils.getCustomIconUrl(galleryInfos.config, driveItems[iconId], resolutions);
				return <img src={src} />;
			} else if (icon.includes('iconset')) {
				return Utils.getSvgIcon(icon);
			}
		}
		return '';
	};

	const { icon, label, type } = props;
	const tooltipId = Utils.generateId();
	const isCustom = type === MenuItemType.Link || type === MenuItemType.Asset || type === MenuItemType.Page || type === MenuItemType.Folder;

	return (
		<StyledHeaderButton onClick={handleClick} data-tip={true} data-for={tooltipId}>
			{ icon &&
				getImgElement()
			}
			{ !icon &&
				<TextButton><Translate value={label} /></TextButton>
			}
			{(UserAgentUtils.isDesktop() && label) &&
				<Tooltip id={tooltipId} text={label} isCustom={isCustom} />
			}
		</StyledHeaderButton>
	);
};

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, driveList } = state;
	return { galleryInfos, driveList };
};

export default connect(mapStateToProps)(HeaderButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/HeaderButton/index.tsx